import { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

export function CompositeContainerBody({ children }: Props) {
  return <div>{children}</div>;
}
